import React, { useMemo } from 'react';
import _ from 'lodash';
import Icons, { Size } from 'components/Common/Icons';
import T from 'localization/LocalizationKeys';
import ModelType from 'components/Model/ModelType';
import Map, { MapControls } from 'components/Map/Map';
import styles from './MapPanel.module.css';
import {
  getLastValueAssets, sortItems
} from 'components/Dashboard/panels/TelemetryCardsPanel/LastValueTelemetryCard';
import CompactTelemetryList from 'components/CompactTelemetryInfo/CompactTelemetryList';

const PinContent = ({ signalValues, isLoading }) => {
  const assetValues = getLastValueAssets(signalValues);
  if (assetValues == null) {
    return <div className={styles.pinContent} />;
  }
  return (<div className={styles.pinContent}>
    { _.map(assetValues, asset => {
      return (<CompactTelemetryList
        key={asset.assetId}
        header={asset.assetDisplayName}
        telemetryModelValues={sortItems(asset.schemas)}
        isLoading={isLoading}
      />);
    }) }
  </div>);
};

const MapPanel = ({ data }) => {
  const controls = useMemo(() => _.compact([
    data?.showMapTypeSelector && MapControls.STYLE,
    data?.showZoomControls && MapControls.ZOOM
  ]), [data?.showMapTypeSelector, data?.showZoomControls]);

  const points = useMemo(() =>
    _.map(_.values(data.coordinateValues.coordinatesPerAsset),
      assetData => ({ ...assetData.coordinate,
        content: <PinContent signalValues={assetData} isLoading={data.coordinateValues.isLoading} />
      })),
  [data.coordinateValues]);

  return <Map points={points} controls={controls} />;
};


MapPanel.info = {
  label: T.dashboard.panels.types.map,
  icon: <Icons.MapMarker size={Size.LARGE}/>,
  help: 'panels/map'
};

MapPanel.properties = {
  coordinateValues: {
    type: 'coordinateSignals'
  }
};

MapPanel.models = [
  {
    type: ModelType.CHECKBOX,
    path: 'showZoomControls',
    label: T.map.controls.showzoomcontrols,
    noTitle: true
  },
  {
    type: ModelType.CHECKBOX,
    path: 'showMapTypeSelector',
    label: T.map.controls.showmaptypeselector,
    noTitle: true
  }
];

export default MapPanel;
